import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  STRIPE_SUBSCRIPTION_STATUS_LABEL,
  STRIPE_SUBSCRIPTION_STATUS_TONE,
} from '../../Enums/stripe-status.enum';
import { PlanSubscriberResponse } from '../../Interfaces/api/backoffice/plan.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class PlanSubscriber {
  subscription_id = '';
  organization_id: string | null = null;
  organization_name: string | null = null;
  stripe_status: string | null = null;
  started_at: string | null = null;
  trial_ends_at: string | null = null;
  cancel_at_period_end = false;
  mrr = 0;

  constructor(data: Partial<PlanSubscriberResponse> = {}) {
    Object.assign(this, data);
  }

  get organizationLabel(): string {
    return this.organization_name || this.organization_id || VALUE_UNRESOLVED;
  }

  get statusLabelKey(): string {
    return this.stripe_status
      ? (STRIPE_SUBSCRIPTION_STATUS_LABEL[this.stripe_status] ?? this.stripe_status)
      : VALUE_UNRESOLVED;
  }

  get statusTone(): StatusTone {
    return this.stripe_status
      ? (STRIPE_SUBSCRIPTION_STATUS_TONE[this.stripe_status] ?? 'neutral')
      : 'neutral';
  }
}
